import React from 'react';
import { Hero } from './components/Hero';
import { BonusSection } from './components/BonusSection';
import { BenefitsSection } from './components/BenefitsSection';
import { PainSection } from './components/PainSection';
import { TestimonialSection } from './components/TestimonialSection';
import { OfferSection } from './components/OfferSection';
import { HowItWorks } from './components/HowItWorks';
import { FaqSection } from './components/FaqSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCta } from './components/FinalCta';
import { SiteFooter } from './components/SiteFooter';
import { StickyBar } from './components/StickyBar';
import { PurchaseToast } from './components/PurchaseToast';
import { useMetaPixel } from './hooks/useMetaPixel';
const META_PIXEL_ID = '1562353072296069';
type AppProps = {
  showScarcity?: boolean;
  showStickyBar?: boolean;
  showPurchaseAlerts?: boolean;
};
export function App({
  showScarcity = true,
  showStickyBar = true,
  showPurchaseAlerts = true
}: AppProps) {
  useMetaPixel(META_PIXEL_ID);
  return <div className={`w-full bg-cream-50 font-sans ${showStickyBar ? 'pb-[72px] sm:pb-0' : ''}`} data-id="element-0" data-mp="3mlj6wpc9h30f">
      <Hero showScarcity={showScarcity} data-id="element-1" data-mp="3rcj31sdk3h1v" />
      <main data-id="element-2" data-mp="3rcsy3udgkeef">
        <BonusSection data-id="element-3" data-mp="3rd191gq0t9mz" />
        <BenefitsSection data-id="element-4" data-mp="5yjsutqtdfe" />
        <PainSection data-id="element-5" data-mp="6htjo98ovic" />
        <TestimonialSection data-id="element-6" data-mp="4n5i12o8na1" />
        <OfferSection data-id="element-7" data-mp="82k72sfnuax" />
        <HowItWorks data-id="element-8" data-mp="2zl3dbpgpde7f" />
        <FaqSection data-id="element-9" data-mp="2zlv7cvunj3vl" />
        <GuaranteeSection data-id="element-10" data-mp="2zmenq84nlk7i" />
        <FinalCta data-id="element-11" data-mp="2zn6biws0edn8" />
      </main>
      <SiteFooter data-id="element-12" data-mp="33mf0zpg0npcz" />
      {showStickyBar && <StickyBar data-id="element-13" data-mp="33ngfk3w8qtzg" />}
      {showPurchaseAlerts && <PurchaseToast liftedForStickyBar={showStickyBar} data-id="element-14" data-mp="38lromcepp0gm" />}
      <noscript data-id="element-15" data-mp="38k6tolohjfi8">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-16" data-mp="38kgnylgkc8tq" />
      </noscript>
    </div>;
}